import { put, all, takeLatest, select } from 'redux-saga/effects';
import { KioskActions, KioskTypes } from './kiosk.redux';
import { selectKioskSlugs } from '../contentRegistry';
import { selectCurrentKioskData } from './kiosk.selectors';
import history from '../../shared/utils/history';
import { ROUTES } from '../../routes/routes';

function* resetCurrentKiosk() {
  yield put(KioskActions.setCurrentKioskId(null));
}

function* handleSetCurrentKioskBySlug({ slug }) {
  if (slug) {
    const { [slug]: kioskId } = yield select(selectKioskSlugs);
    yield put(KioskActions.setCurrentKioskId(kioskId));

    const kioskData = yield select(selectCurrentKioskData);

    if (!kioskData) {
      history.push(ROUTES.notFound);
    }
  } else {
    yield resetCurrentKiosk();
  }
}

export default function* startupSaga() {
  yield all([takeLatest(KioskTypes.SET_CURRENT_KIOSK_BY_SLUG, handleSetCurrentKioskBySlug)]);
}
